// src/utils/ContainerInitializer.ts

/**
 * Utility for proper container initialization and state synchronization
 */
export class ContainerInitializer
{
  /**
   * Create container element with proper initialization
   */
  static createContainerElement(
    width: number,
    height: number,
    x?: number,
    y?: number,
    color?: string
  ): HTMLElement {
    const container = document.createElement('div')
    container.className = 'container advanced-container new'

    container.style.position = 'absolute'
    container.style.width = `${width}px`
    container.style.height = `${height}px`

    if (x !== undefined) container.style.left = `${x}px`
    if (y !== undefined) container.style.top = `${y}px`
    if (color) container.style.borderColor = color

    return container
  }
}
